// Persistent per-browser visitor ID for like/visit dedup.
const KEY = "bv_visitor_id";
export function getVisitorId() {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = "v-" + Math.random().toString(36).slice(2) + "-" + Date.now().toString(36);
    localStorage.setItem(KEY, v);
  }
  return v;
}
